class NotificationModelConsts {
  public static readonly EmailMaxLength: number = 255;
}

export default NotificationModelConsts;
